import React, {Fragment} from "react";
import {Link} from "react-router";

import Panel from "./Panel";
import Right from "./Right";
import FormItem from "./FormItem";

import langs from "./langs/appIndex";
import phpLangs from "./langs/phpIndex";

import {api} from "./baseFunctions";


export default class GroupsPage extends React.Component {

    state = {
        data: [],
        editing: false,
        firms: [],
        sheets: [],
    };

    emptyQuestion = JSON.stringify({
        type: "",
        question: "",
        options: [],
        children: [],
        correct: "",
        isNew: true,
    });

    componentDidMount(){
        this.getData();
    }

    getData = () => {
        api("POST", {type: "getGroups"}, (data) => {
            console.log("Got sheets", data);
            if(!data.error)
            {
                this.setState({
                    data: data.data,
                });
            }
        }, this.props.auth);
        api("POST", {type: "getFirms"}, (data) => {
            console.log("Got firms", data); 
            this.setState({
                firms: data.data
            })
        }, this.props.auth);

        api("POST", {type: "getSheets"}, (data) => {
            this.setState({
                sheets: data.data,
            });
        }, this.props.auth);
    }

    getComponents(sheetIDs)
    {
        let formatter = (children = [], depth = 0) => ([
            ...children.map(child => ({
                id: child.questionID,
                type: child.type,
                question: child.question,
                depth,
                depthText: [...Array(depth + 1)].join("-"),
            })),
            ...children.map(child => formatter(child.children, depth + 1)).flat(),
        ])
        const sheets = sheetIDs.map(id => this.state.sheets.find(sheet => sheet.sheetID === id));
        const componets = sheets.map(sheet => formatter(sheet.questions));
        return componets.flat();
    }

    updateNode(ref, node, key, value)
    {
        node[key] = value;
        this.setState({
            editing: {
                ...this.state.editing,
                questions: ref,
            }
        });
    }

    render(){
        const LANG = phpLangs[this.props.lang];
        const APP_LANG = langs[this.props.lang];
        const editing = this.state.editing;
        console.log("Editing", editing);

        const activeSheets = editing ? editing.data : [];
        const activeCols = editing && editing.extras ? editing.extras : [];
        console.log("Get components", this.getComponents(activeSheets));
        return (<Right title="Skema grupper" token={this.props.auth} lang={this.props.lang}>
            {
                this.state.editing && <Panel title={`Retter "${editing.name}"`}>
                    <FormItem name="Navn">
                        <input type="text" className="form-control col-md-7 col-xs-12" required="" defaultValue={editing.name} onBlur={(e) => this.setState({
                            editing: {
                                ...this.state.editing,
                                name: e.target.value,
                            }
                        })} required={true}/>
                    </FormItem>
                    <FormItem name={<React.Fragment>Ikon [<a href="https://fontawesome.com/v4/icons/" target="_blank">Alle ikoner</a>]</React.Fragment>}>
                        <input type="text" className="form-control col-md-7 col-xs-12" required="" defaultValue={editing.icon} onBlur={(e) => this.setState({
                            editing: {
                                ...this.state.editing,
                                icon: e.target.value,
                            }
                        })} required={true}/>
                    </FormItem>
                    <FormItem name="Skemaer">
                    {/* <FormItem name="Skemaer (IDs sepereres med ',')">
                        <input type="text" className="form-control col-md-7 col-xs-12" required="" defaultValue={editing.data.join(",")} onBlur={(e) => this.setState({
                            editing: {
                                ...this.state.editing,
                                data: e.target.value.split(","),
                            }
                        })}/> */}

                        <select className="form-control col-md-7 col-xs-12" multiple={true} style={{height: "400px"}} onChange={e => {
                            const IDs = [...e.target.selectedOptions].map(option => Number(option.value));
                            this.setState({
                                editing: {
                                    ...this.state.editing,
                                    data: IDs,
                                }
                            });
                        }}>
                            {
                                this.state.sheets.map(d => <option selected={activeSheets.some(id => d.sheetID === id)} value={d.sheetID}>[{d.sheetID}] {d.name}</option>)
                            }
                        </select>
                    </FormItem>
                    <FormItem name="Extra kolonner">
                        <select className="form-control col-md-7 col-xs-12" multiple={true} style={{height: "200px"}} onChange={e => {
                            const IDs = [...e.target.selectedOptions].map(option => Number(option.value));
                            this.setState({
                                editing: {
                                    ...this.state.editing,
                                    extras: IDs,
                                }
                            });
                        }}>
                            {
                                this.getComponents(activeSheets).map(d => <option selected={activeCols.some(id => d.id === id)} value={d.id}>{d.depthText}{d.depth > 0 && ">"} [{d.id}] [{d.type}] {d.question}</option>)
                            }
                        </select>
                    </FormItem>
                    <FormItem name="Firma">
                        <select className="form-control col-md-7 col-xs-12" defaultValue={editing.firmID} onChange={(e) => this.setState({
                            editing: {
                                ...this.state.editing,
                                firmID: e.target.value,
                            }
                        })}>
                            {
                                this.state.firms.map(d => <option value={d.id}>{d.name}</option>)
                            }
                        </select>
                    </FormItem>

                    <button onClick={() => api("POST", {type: "saveGroupData", data: this.state.editing}, (resp) => {
                        if(!resp.error)
                        {
                            this.setState({
                                editing: false,
                            });
                            this.getData();
                        }
                    }, this.props.auth)}>
                        Gem
                    </button>
                </Panel>
            }
            <Panel title="Oversigt">
                <button onClick={() => this.setState({
                    editing: {
                        firmID: this.state.firms[0].id,
                        name: "Ny gruppe",
                        data: [],
                        icon: "",
                    }
                })}>Opret nyt</button>
                <table className="table table-striped jambo_table bulk_action" id="ras" style={this.state.data.length === 0 ? {display: "none"} : {}}>
                    <thead>
                        <tr className="headings">
                        <th className="column-title">{LANG.ID}</th>
                        <th className="column-title">{LANG.NAME}</th>
                        <th className="column-title">Skemaer</th>
                        <th className="column-title">Ikon</th>
                        <th className="column-title">Firma</th>
                        <th className="column-title"></th>
                        <th className="column-title"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.data.map((sheet, key) => (<tr className="headings" key={"user" + key}>
                            <td className="column-title">{sheet.id}</td>
                            <td className="column-title">
                                    {sheet.name}
                            </td>
                            <td className="column-title">
                                    {sheet.data.length}
                            </td>
                            <td className="column-title">
                                    {sheet.icon}
                            </td>
                            <td className="column-title">
                                    {this.state.firms.length > 0 && this.state.firms.find(firm => firm.id === sheet.firmID).name} [{sheet.firmID}]
                            </td>
                            <td className="column-title">
                                <Link to={"/groups"} onClick={() => this.setState({editing: {
                                    ...sheet,
                                    data: sheet.data.map(d => d.sheetID)
                                }})}>Ret</Link>
                            </td>
                            <td className="column-title">
                                <Link to={"/groups"} onClick={() => {
                                    api("POST", {type: "removeGroup", id: sheet.id}, (data) => {
                                        this.getData();
                                    }, this.props.auth);
                                }}>Slet</Link>
                            </td>
                          </tr>))
                        }
                        
                    </tbody>
                </table>
        </Panel>

        </Right>);
    }
}


// WEBPACK FOOTER //
// ./src/components/GroupsPage.js